import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LoanVendorStore } from '../stores/loanVendorStore';

export const useLoanVendorStore = () =>
  useContext<{
    loanVendorStore: LoanVendorStore;
  }>(StoreContext);